var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95335 23.0347C2.3414 20.4228 2.3414 16.188 4.95335 13.576L13.5522 4.97721C16.1641 2.36526 20.3989 2.36526 23.0109 4.97721C25.6228 7.58916 25.6228 11.824 23.0109 14.4359L14.4121 23.0347C11.8001 25.6467 7.56529 25.6467 4.95335 23.0347ZM11.2213 10.1365L14.9664 6.39143C16.7973 4.56052 19.7658 4.56052 21.5967 6.39142C23.4276 8.22232 23.4276 11.1908 21.5967 13.0217L17.8516 16.7668L11.2213 10.1365ZM9.80706 11.5507L6.36756 14.9902C4.53666 16.8211 4.53666 19.7896 6.36756 21.6205C8.19846 23.4514 11.1669 23.4514 12.9978 21.6205L16.4373 18.181L9.80706 11.5507Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillOutline);
export default __webpack_public_path__ + "static/media/pill_outline.74f45698efffbf232ceb519c21079939.svg";
export { ForwardRef as ReactComponent };